import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { cleanEmpty } from 'utils/genericFunctions';
import { Types, IConsultarEstatisticaRequest } from './types';
import {
	consultarEstatisticaFailure,
	consultarEstatisticaSuccess,
} from './actions';

function* consultarEstatistica(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: IConsultarEstatisticaRequest } = request;

	// yield put(consultarEstatisticaClear());

	let body = { ...payload };

	delete body.current;

	body = cleanEmpty(body) as IConsultarEstatisticaRequest;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_SGU_API,
		`estatisticas`,
		body,
	);

	if (response.status === 200) {
		yield put(consultarEstatisticaSuccess(response));
	} else {
		yield put(consultarEstatisticaFailure());
	}
}

export default all([
	takeLatest(Types.CONSULTAR_ESTATISTICA_REQUEST, consultarEstatistica),
]);
